import React from 'react'
import { connect } from "react-redux";
import { SetDepositSuccessPage } from '$Deposits/store/actions/DepositAction'
import OpenPayModal from '../Components/OpenPayModal'
import { WindowOpen } from '$Deposits/store/actions/DepositEvent'

class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    componentDidMount() {


    }
    componentWillUnmount() {

    }


    render() {

        return (
            <>
                <OpenPayModal
                    onClick={() => {
                        this.props.SetDepositSuccessPage(true)
                        WindowOpen && WindowOpen()
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
    DepositBankActive: state.DepositBankActive,
});
const mapDispatchToProps = {
    SetDepositSuccessPage: (data) => SetDepositSuccessPage(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(NextStep);


